import urls from '../api_urls/inciManagement'
import { _post, _upload } from '@/axios/request'

// get inci table
export function getTableData (params) {
  return _post(urls.GET_TABLE_LIST, params)
}

// upload file
export function uploadFile (params) {
  console.log(params)
  return _upload(urls.UPLOAD_FILE, params)
}

// update inci detail
export function updateDetail (params) {
  return _post(urls.UPDATE_DETAIL, params)
}

// get inci detail
export function getDetail (params) {
  return _post(urls.GET_DETAIL, params)
}

// get country list
export function getCountryList (params) {
  return _post(urls.GET_COUNTRY_LIST, params)
}

export function updateInci (params) {
  return _post(urls.UPDATE_INCI, params)
}

// FIND_INCI
export function findInciFilter (params) {
  return _post(urls.FIND_INCI, params)
}


// WEBPACK FOOTER //
// ./src/axios/api/inciManagement.js